import React, { useCallback, useEffect } from 'react';
import { useFormEvents } from '@lib/common';
import { StyledDialog, ErrorDisplay } from '@lib/common';
import { PropertyDeviceForms } from 'app/state/property-device/property-device.forms';
import { DialogContent, Typography, DialogActions, Button } from '@material-ui/core';
import { FormStatus } from '@lib/state';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSuccess?: () => void;
}

export function DeviceDeleteModal({ open, onClose, onConfirm, onSuccess }: Props) {
  const [{ status, error }, reset] = useFormEvents(PropertyDeviceForms.DeleteDevice);

  useEffect(() => {
    if (status === FormStatus.Success) {
      if (onSuccess) onSuccess();
      else onClose();
      reset();
    }
  }, [status, open, onClose, onSuccess, reset]);

  const handleClose = useCallback(() => {
    onClose();
    reset();
  }, [onClose, reset]);

  return (
    <StyledDialog open={open} title="Delete Device" onClose={handleClose}>
      <ErrorDisplay error={error} />
      <DialogContent data-testid="confirmActionDisplay">
        <Typography>Are you sure you want to delete this device?</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="contained"
          color="default"
          disabled={!!status && status === FormStatus.Pending}
          onClick={handleClose}
          data-testid="confirmCancelButton"
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          color="primary"
          disabled={!!status && status === FormStatus.Pending}
          onClick={() => {
            onConfirm();
          }}
          data-testid="confirmButton"
        >
          Delete
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
